/* reveal.js — scroll-into-view animations (progressive enhancement).
   Strategy that can never leave visible content stuck hidden:
   only elements BELOW the fold get the hidden `.reveal` state; anything
   already on screen is left visible. As you scroll, below-fold blocks get
   `.in` and animate up. Disabled under prefers-reduced-motion; with no JS,
   nothing is ever hidden. (Ported verbatim from the curro-redesign prototype.) */
(function () {
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  document.documentElement.classList.add("js-reveal");

  var SEL = ".report-hero,.viz-card,.callout,.bd-chart,.tbl-wrap,.hist-card,.report-foot,.section-title,.sources-grid,.main .panel";
  var SKIP = ".scrim,.modal,.topbar,.tabbar,.opt-sheet,.stepper";

  function vh() { return window.innerHeight || document.documentElement.clientHeight; }
  function inView(el) {
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    return r.top < vh() * 0.9 && r.bottom > 0;
  }

  // Tag only below-fold blocks as hidden; leave on-screen blocks visible.
  function tag() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.__rev) return;
      if (el.closest(SKIP)) { el.__rev = true; return; }
      if (el.classList.contains("tbl-wrap") && el.closest(".viz-card")) { el.__rev = true; return; }
      el.__rev = true;
      if (!inView(el)) el.classList.add("reveal");
    });
  }

  function check() {
    tag();
    var els = document.querySelectorAll(".reveal:not(.in)");
    for (var i = 0; i < els.length; i++) { if (inView(els[i])) els[i].classList.add("in"); }
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(check, 40); }

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("load", schedule);

  function start() {
    check();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start();
  else document.addEventListener("DOMContentLoaded", start);
})();
